module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle0",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Concertina")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("noun, adjective, & verb")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("noun")]), _vm._v(". 1. A portable free-reed musical instrument consisting of a pair of bellows usu. Polygonal in form, with a set of finger-studs at each end controlling valves which admit wind to the reeds.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("2. In full "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("concertina wire")]), _vm._v(". Wire used for entanglements.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("attrib")]), _vm._v(". Or as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adjective")]), _vm._v(". (Able to be) compressed or closed like a concertina; involving such action.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("verb trans. & intrans")]), _vm._v(". Shut up like a concertina; compress; collapse; wrinkle.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b7fd18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429983952_fm02.vue
// module id = 69
// module chunks = 0